import React from "react";
import { Link, Route, Switch } from "react-router-dom";
import ArtisanCategoriesList from "./ArtisanCategoriesList";
import ArtisanCategoriesForm from "./ArtisanCategoriesForm";
import Content from "../../../_psb/layout/Content";
import SubHeader from "../../../_psb/layout/sub-header/SubHeader";
import Search from "../../../components/form/Search";
import { connect } from "react-redux";
import { setSearchValueAction } from "../../../modules/artisanCategories/Actions";
import { FormattedMessage, injectIntl } from "react-intl";
import getLangData from "../../../utils/getLangData";

const artisanCategories = (props) => {
	const { setSearchValue } = props;
	return (
		<>
			<SubHeader
				title={getLangData().general_words.artisan_categories}
				Component={() => (
					<>
						<Switch>
							{/* <Route
								exact
								path="/artisan-categories"
								component={() => {
									return (
										<>
											<span className="kt-subheader__separator kt-subheader__separator--v"></span>
											<Search setSearchValue={setSearchValue} />
										</>
									);
								}}
							/> */}
						</Switch>
					</>
				)}
			>
				<Switch>
					<Route
						exact
						path="/artisan-categories"
						component={() => (
							<Link to="/artisan-categories/create" className="btn btn-primary">
								{getLangData().buttons.add_new}
							</Link>
						)}
					/>

					{/* <Route
						exact
						path={["/artisan-categories/create", "/artisan-categories/:id"]}
						component={() => {
							return (
								<Link
									to="/artisan-categories"
									className="btn-label-brand btn btn-bold"
								>
									{/* Back To List{" "} 
									<FormattedMessage id="BACK.TO.LIST" />
								</Link>
							);
						}}
					/> */}
				</Switch>
			</SubHeader>
			<Content>
				<Switch>
					<Route
						exact
						path="/artisan-categories"
						component={ArtisanCategoriesList}
					/>
					<Route
						exact
						path="/artisan-categories/create"
						component={ArtisanCategoriesForm}
					/>
					<Route
						exact
						path="/artisan-categories/:id"
						component={ArtisanCategoriesForm}
					/>
				</Switch>
			</Content>
		</>
	);
};

const mapDispatchToProps = {
	setSearchValue: setSearchValueAction,
};

export default injectIntl(connect(null, mapDispatchToProps)(artisanCategories));
